import http from 'src/http'
import appConfigService from './AppConfigService'
import utilsService from './UtilsService';
import apiService from 'src/services/ApiService';

export default {

    login(username, password) {

        const LOGIN_URL = appConfigService.apiUrl() + '/api/login';

        //LOGIN REAL
        return http.post(LOGIN_URL, {
            credentials: {
                username: username
            },
            password: password
        }).then(function (response) {
            return response.data
        }).then(user => {

            if (user.username !== "admin") {

                http.defaults.headers.common['Authorization'] = 'Bearer ' + user.access_token

                return http.get(appConfigService.apiUrl() + '/api/users/username/' + user.username).then(response => {

                    let userReturned = response.data.data;

                    user.name = userReturned.name;
                    user.email = userReturned.email;
                    user.phone = userReturned.phone;
                    user.passwordExpired = userReturned.passwordExpired;
                    user.enabled = userReturned.enabled;

                    return user;
                });
            }

            user.name = "";
            return user;

        }).then(user => {
            return apiService.search({
                excludeApi: true,
                uri: "/f/ba"
            }).then(response => {

                user.businessLines = [];

                _.orderBy(response, [businessLine => businessLine.labelPt.toLowerCase()], ['asc']).map(businessLine => {

                    if (utilsService.hasRole(user.roles, businessLine.id)) {

                        let businessLineRow = Object.assign({}, businessLine);
                        businessLineRow.contracts = [];

                        _.orderBy(businessLine.contracts, [contract => contract.labelPt.toLowerCase()], ['asc']).map(contract => {
                            if (utilsService.hasRole(user.roles, contract.id)) {
                                businessLineRow.contracts.push(contract);
                            }
                        });

                        user.businessLines.push(businessLineRow)
                    }
                });

                return user;
            });
        }).catch(function (error) {
            throw error
        });
    },

    logout() {

        const LOGOUT_URL = appConfigService.apiUrl() + '/api/logout';

        return http.post(LOGOUT_URL).then(function (response) {

            console.log("LOGOUT", response);

            return response.data

        }).catch(function (error) {

            console.log("LOGOUT ERROR", error);

            return error;
        });
    },

    changePassword(payload) {

        const URL = appConfigService.apiUrl() + '/api/users/changePassword';

        let successMessage = payload.successMessage;

        return http.put(URL,
            payload
        ).then(function (response) {
            return response.data
        });
    },

    retrievePassword(payload) {

        const URL = appConfigService.apiUrl() + '/api/forgetPassword/retrievePassword';

        // let successMessage = payload.successMessage;

        return http.post(URL,
            payload
        ).then(function (response) {
            return response.data
        });
    },

    changePasswordByToken(payload) {

        const URL = appConfigService.apiUrl() + '/api/forgetPassword/changePassword';

        // let successMessage = payload.successMessage;

        return http.post(URL,
            payload
        ).then(function (response) {
            return response.data
        });
    },

    loginFake(username, password) {
        return new Promise(function (resolve) {
                resolve({
                    username: username,
                    roles: []
                })
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/services/AuthService.js